const BookingModalDic = {
    'trial' : {
        'fa' : 'کلاس آزمایشی',
    }
}
export default BookingModalDic